import React from "react";
import { get } from "lodash";
import { useTranslate } from "react-admin";

const Title = ({ record, resource, source }) => {
  const translate = useTranslate();
  return (
    <span>
      {resource && translate(`resources.${resource}.name`, { smart_count: 1 })}
      {resource && " "}
      {get(record, source)}
    </span>
  );
};

export default Title;
